export const getCurrency = () => {
  return 'USD';
};
